import {t} from 'i18next';
import {AurDataGridColDef} from '../types/types';

const roundToDecimals = (numStr: string | number, roundLength = 5): string => {
  const num = parseFloat(numStr.toString());
  if (isNaN(num)) return '0';

  const parts = numStr.toString().split('.');
  const afterDecimalLength = parts.length > 1 ? parts[1].length : 0;

  if (afterDecimalLength == 0) return parts[0];
  if (afterDecimalLength < roundLength) return num.toFixed(afterDecimalLength);
  return num.toFixed(roundLength);
};

export const getKpiPanelProjectColumns = (): AurDataGridColDef[] => [
  {
    field: 'projectId',
    headerName: t('kpiPanel.projectId'),
    width: 268,
    sortable: true,
    headerClassName: 'kpi-panel-header',
    cellClassName: 'kpi-panel-header',
  },
  {
    field: 'projectName',
    headerName: t('kpiPanel.projectName'),
    sortable: false,
    width: 610,
    isBorderNotRequired: true,
  },
];

export const getKpiPanelDatasetsColumns = (): AurDataGridColDef[] => [
  {
    field: 'projectName',
    headerName: t('kpiPanel.projectName'),
    headerClassName: 'kpi-panel-header',
    cellClassName: 'kpi-panel-header',
    sortable: true,
    width: 268,
  },
  {
    field: 'workspaceName',
    headerName: t('kpiPanel.workspaceName'),
    width: 360,
    sortable: false,
    renderCell: (params) => (
      <div className="kpi-panel-cell">{params.row.workspaceName}</div>
    ),
  },
  {
    field: 'datasetName',
    headerName: t('kpiPanel.datasetName'),
    width: 220,
    sortable: false,
    isBorderNotRequired: true,
  },
];

export const getKpiPanelProductionColumns = (): AurDataGridColDef[] => [
  {
    field: 'projectName',
    headerName: t('kpiPanel.projectName'),
    headerClassName: 'kpi-panel-header',
    cellClassName: 'kpi-panel-header',
    sortable: true,
    width: 268,
  },
  {
    field: 'workspaceName',
    headerName: t('kpiPanel.workspaceName'),
    width: 360,
    sortable: false,
    renderCell: (params) => (
      <div className="kpi-panel-cell">{params.row.workspaceName}</div>
    ),
  },
  {
    field: 'productionDetails',
    headerName: t('kpiPanel.productionDetails'),
    width: 220,
    sortable: false,
    isBorderNotRequired: true,
    renderCell: (params) => (
      <div className="kpi-multiline-cell">
        {params.row?.productionDetails?.name}
        <br />
        <span className="typo-text body4_size mist-700-color">
          {roundToDecimals(params.row?.productionDetails?.dataSize ?? '0')}
          {` ${t('welcomeScreenSingleClient.gBExportedDataSize')}`}
        </span>
      </div>
    ),
  },
];
